import { MODES, MODE_ORDER } from '../../hooks/useChatMode';

/**
 * Three-way interaction mode picker.
 *
 * Deliberately one control, not two (modality x turn-taking): most of the
 * combinations that framing produces are incoherent — hands-free voice input
 * with text-only output still requires reading the screen, which defeats it.
 */
export default function ModeSelector({ mode, onChange, voiceSupported }) {
  const active = MODES[mode];

  return (
    <div className="px-3 py-2 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div
        role="radiogroup"
        aria-label="Conversation mode"
        className="grid grid-cols-3 gap-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-xl"
      >
        {MODE_ORDER.map((id) => {
          const m = MODES[id];
          const selected = id === mode;
          const locked = id !== 'type' && !voiceSupported;
          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={locked}
              onClick={() => onChange(id)}
              className={`px-1 py-2 rounded-lg text-center leading-tight transition-colors ${
                selected
                  ? 'bg-white dark:bg-gray-900 shadow-sm'
                  : 'hover:bg-white/60 dark:hover:bg-gray-900/40'
              } ${locked ? 'opacity-40 cursor-not-allowed' : ''}`}
            >
              <span
                className={`block text-xs font-semibold ${
                  selected
                    ? 'text-indigo-600 dark:text-indigo-400'
                    : 'text-gray-600 dark:text-gray-300'
                }`}
              >
                {m.label}
              </span>
              <span className="block text-xs text-gray-500 dark:text-gray-400">
                {m.sub}
              </span>
            </button>
          );
        })}
      </div>
      <p className="mt-1.5 px-1 text-xs text-gray-500 dark:text-gray-400 text-center">
        {voiceSupported
          ? active.hint
          : 'Voice needs Chrome or Safari — this browser can only type.'}
      </p>
    </div>
  );
}
